import { render, staticRenderFns } from "./jcsz.vue?vue&type=template&id=1df13244&"
import script from "./jcsz.vue?vue&type=script&lang=js&"
export * from "./jcsz.vue?vue&type=script&lang=js&"
import style0 from "./jcsz.vue?vue&type=style&index=0&id=1df13244&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports